import * as actionTypes from '../utils/constants';

const initialState = {};
const newsAnnouncementDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_NEWSANNOUNCEMENTLIST: {
      const newState = {
        ...state,
      };
      newState.newsAnnouncementDataReducer = action.action;
      return newState;
    }
    default: {
      return state;
    }
  }
};

export default newsAnnouncementDataReducer;